<mat-dialog-content style="min-width: 480px; max-width: 720px">
  <lemon-dialog-header>
    {{ onOlemassaolevaTestitapaus ? 'Hallinnoi kirjauksen LLM-testisettejä' : 'Lisää LLM-testisettiin' }}
  </lemon-dialog-header>

  @if (tila() === 'lataa') {
    <div style="display: flex; align-items: center; gap: 12px; padding: 16px 0">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Tunnistetaan kategoriaa…</span>
    </div>
  }

  @if (tila() === 'virhe') {
    <div style="padding: 8px 0">
      <p>{{ latausvirhe() }}</p>
    </div>
  }

  @if (tila() === 'deterministinen') {
    <div style="padding: 8px 0">
      <p style="font-weight: 500">Tätä kirjausta ei voi lisätä testisettiin.</p>
      <p style="margin-top: 8px">
        Kirjaus ratkaistaan deterministisellä säännöllä (kategoria
        <code>{{ kategoria() }}</code
        >). LLM-testit eivät kata deterministisiä kategorioita, koska niiden lopputulos on sama LLM:stä riippumatta.
      </p>
    </div>
  }

  @if (tila() === 'valittavissa' || tila() === 'tallennetaan') {
    <p style="margin: 0 0 4px 0">
      Kategoria: <code>{{ kategoria() }}</code>
    </p>

    @if (onOlemassaolevaTestitapaus) {
      <p style="margin: 12px 0 4px 0; font-size: 13px; color: #555">Tämä kirjaus on osa alla rastitettuja LLM-testisettejä. Poista rasti poistaaksesi kirjauksen kyseisestä setistä.</p>
    } @else {
      <p style="margin: 12px 0 4px 0; font-size: 13px; color: #555">Valitse setit, joihin kirjaus lisätään LLM-testaukseen.</p>
    }

    <h3 style="margin: 16px 0 8px 0; font-size: 14px">Olemassa olevat setit</h3>

    @if (onOlemassaolevaTestitapaus && valitutSettiAvaimet().size === 0 && !(uudenSetinNimi().value() ?? '').trim()) {
      <div style="font-size: 13px; color: #b26a00; margin-bottom: 8px">Kirjaus poistetaan kaikista LLM-testiseteistä.</div>
    }

    @if (setit().length === 0) {
      <div style="font-size: 13px; color: #666; margin-bottom: 8px">Tähän kategoriaan ei ole vielä settejä. Voit luoda uuden alla.</div>
    } @else {
      <div style="display: flex; flex-direction: column; gap: 4px; max-height: 280px; overflow-y: auto">
        @for (setti of setit(); track setti.avain) {
          <mat-checkbox [checked]="onSettiValittu(setti.avain)" [disabled]="tila() === 'tallennetaan'" (change)="toggleSetti(setti.avain, $event.checked)">
            {{ setti.nimi }}
            <span style="color: #888; font-size: 12px; margin-left: 6px">({{ setti.testitapausLkm }} kpl)</span>
          </mat-checkbox>
        }
      </div>
    }

    <h3 style="margin: 16px 0 8px 0; font-size: 14px">Luo uusi setti</h3>
    <p style="margin: 0 0 8px 0; font-size: 13px; color: #555">Annettu setti luodaan ja kirjaus lisätään siihen valittujen lisäksi.</p>

    <mat-form-field style="width: 100%">
      <mat-label>Uuden setin nimi</mat-label>
      <input matInput [formField]="uudenSetinNimi" placeholder="esim. Q2 ostokuitit" />
    </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (tila() === 'deterministinen' || tila() === 'virhe') {
    <app-secondary-button (click)="peruuta()" actionId="Sulje (lisää testisettiin dialog, deterministinen)">Sulje</app-secondary-button>
  }
  @if (tila() === 'valittavissa' || tila() === 'tallennetaan') {
    <app-secondary-button (click)="peruuta()" [disabled]="tila() === 'tallennetaan'" actionId="Peruuta (lisää testisettiin dialog)">Peruuta</app-secondary-button>
    <app-primary-button (click)="vahvista()" [disabled]="!voiVahvistaa() || tila() === 'tallennetaan'" actionId="Vahvista (lisää testisettiin dialog)">
      @if (tila() === 'tallennetaan') {
        <mat-spinner diameter="16" style="display: inline-block; margin-right: 6px"></mat-spinner>
      }
      Vahvista
    </app-primary-button>
  }
</mat-dialog-actions>
